<template>
  <div
    class="product-box-set-list"
    :class="'product-box-set-list--items_' + listItems.length"
  >
    <product-box-set-item
      class="product-box-slider__item"
      v-for="(product, index) in listItems"
      :key="product.id"
      :product-box-data="product"
      :hide-counter-button="hideCartButton"
      :hide-quickfacts="hideQuickfacts"
      :show-quickfacts-with-desc="showQuickfactsWithDesc"
      :state="getProductState(product)"
      :tracking-additional="{
        position: index,
        list: trackingList
      }"
      @addToBasket="addToBasketHandler"
      @quantityChange="quantityChangeHandler"
      @addToWishlist="addToWishlistHandler"
      @removeFromWishlist="removeFromWishlistHandler"
    />
  </div>
</template>

<script lang="ts">
  import {Options, Prop} from 'vue-property-decorator';
  import {productBoxContainerMixin, ProductBoxContainerClass} from '../../../bps/utilities/vueMixins/productBoxContainerMixin/productBoxContainerMixin';
  import ProductBoxSetItem from '../productBoxSetItem/productBoxSetItem.vue';

  @Options({
    name: 'product-box-set-list',
    components: {
      ProductBoxSetItem
    },
    mixins: [productBoxContainerMixin]
  })
  export default class ProductBoxSetList extends ProductBoxContainerClass {
    @Prop({default: false, type: Boolean})
    readonly hideQuickfacts: boolean;

    @Prop({default: false, type: Boolean})
    readonly showQuickfactsWithDesc: boolean;
  }
</script>
